/* =========================================================
   CARTWALA THEME — lightweight vanilla JS
   No framework. Progressive enhancement over Liquid-rendered HTML.
   ========================================================= */
(function () {
  'use strict';

  var routes = window.Cartwala && window.Cartwala.routes ? window.Cartwala.routes : {
    cart_add_url: '/cart/add.js',
    cart_change_url: '/cart/change.js',
    cart_url: '/cart.js',
    predictive_search_url: '/search/suggest.json'
  };

  /* ---------------- Utilities ---------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function trapFocus(el) {
    var focusable = qsa('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])', el);
    if (!focusable.length) return;
    focusable[0].focus();
  }
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || '₹{{amount}}').replace('{{amount}}', value);
  }
  function showToast(message) {
    var toast = qs('#cw-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }

  /* ---------------- Mobile nav ---------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mobile-nav-toggle]');
    if (toggle) {
      var nav = qs('#mobile-nav');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---------------- Search drawer ---------------- */
  var searchDrawer = qs('#search-drawer');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) {
      if (searchDrawer) {
        searchDrawer.classList.add('is-open');
        var input = qs('input[type="search"]', searchDrawer);
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
    }
    if (e.target.closest('[data-search-close]') || (searchDrawer && e.target === searchDrawer)) {
      if (searchDrawer) searchDrawer.classList.remove('is-open');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchDrawer) searchDrawer.classList.remove('is-open');
      var cd = qs('#cart-drawer'); if (cd) cd.classList.remove('is-open');
      var fd = qs('#filter-drawer'); if (fd) fd.classList.remove('is-open');
    }
  });

  var searchInput = searchDrawer ? qs('input[type="search"]', searchDrawer) : null;
  var searchResults = searchDrawer ? qs('.predictive-results', searchDrawer) : null;
  var searchTimer;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var val = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (val.length < 2) { if (searchResults) searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(val) + '&resources[type]=product,collection,query&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!searchResults) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="text-muted" style="padding:1rem 0;">No products found for "' + val + '".</p>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.featured_image ? p.featured_image.url : '';
              return '<a class="predictive-result" href="' + p.url + '">' +
                (img ? '<img src="' + img + '" width="48" height="48" alt="">' : '') +
                '<span><span style="display:block;font-weight:600;font-size:.9rem;">' + p.title + '</span>' +
                '<span class="text-muted" style="font-size:.8rem;">' + p.price + '</span></span></a>';
            }).join('');
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------------- FAQ accordion (native <details>, JS enhances icon only) ---------------- */

  /* ---------------- Product gallery ---------------- */
  qsa('[data-product-gallery]').forEach(function (gallery) {
    var main = qs('[data-gallery-main] img', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        qsa('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) {
          main.removeAttribute('srcset');
          main.src = thumb.dataset.fullSrc || thumb.querySelector('img').src;
        }
      });
    });
  });

  /* ---------------- Quantity selector ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty-selector');
    var input = qs('input', wrap);
    var step = parseInt(btn.dataset.qtyStep, 10);
    var val = Math.min(Number(input.max) || Infinity, Math.max(Number(input.min) || 1, (parseInt(input.value, 10) || 1) + step));
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Cart page: live quantity update ---------------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.qty-selector input[name^="updates["]');
    if (!input) return;
    var line = input.closest('[data-cart-line-key]');
    if (!line) return;
    var key = line.dataset.cartLineKey;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    input.disabled = true;
    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        qsa('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
        if (qty === 0 || !cart.items.some(function (it) { return it.key === key; })) {
          line.remove();
          if (cart.item_count === 0) { window.location.reload(); }
          return;
        }
        var item = cart.items.filter(function (it) { return it.key === key; })[0];
        var priceEl = qs('[data-line-price]', line);
        if (item && priceEl) priceEl.textContent = money(item.final_line_price);
        input.disabled = false;
        input.value = qty;
      })
      .catch(function () {
        input.disabled = false;
        showToast('Could not update your cart. Please try again.');
      });
  });

  /* ---------------- Variant swatches -> update hidden variant id + price ---------------- */
  qsa('[data-variant-picker]').forEach(function (picker) {
    var variantsJson = picker.dataset.variants ? JSON.parse(picker.dataset.variants) : [];
    var form = picker.closest('form');
    var idInput = qs('[name="id"]', form);
    var priceEls = qsa('[data-product-price]');
    var atcBtn = qs('[data-add-to-cart]', form);
    var stickyAtcBtn = qs('.sticky-atc [data-add-to-cart], .sticky-atc button');

    function getSelected() {
      var selected = {};
      qsa('input[type="radio"]:checked', picker).forEach(function (r) {
        selected[r.name] = r.value;
      });
      return selected;
    }
    function findVariant(selected) {
      return variantsJson.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected['option' + (i + 1)] === opt;
        });
      });
    }
    function renderPrice(el, variant) {
      if (!el) return;
      if (variant.compare_at_price_formatted) {
        el.innerHTML = '<span class="price__sale">' + variant.price_formatted + '</span>' +
          '<span class="price__compare">' + variant.compare_at_price_formatted + '</span>' +
          '<span class="badge" style="background:var(--destructive);color:var(--destructive-foreground);">Save ' + variant.discount_pct + '%</span>';
      } else {
        el.innerHTML = '<span>' + variant.price_formatted + '</span>';
      }
    }
    picker.addEventListener('change', function () {
      var selected = getSelected();
      var variant = findVariant(selected);
      qsa('.swatch', picker).forEach(function (s) { s.classList.remove('is-selected'); });
      qsa('input[type="radio"]:checked', picker).forEach(function (r) {
        r.closest('.swatch').classList.add('is-selected');
      });
      if (variant) {
        if (idInput) idInput.value = variant.id;
        priceEls.forEach(function (el) { renderPrice(el, variant); });
        var gallery = qs("[data-product-gallery]", form.closest(".product-layout"));
        if (gallery && variant.media_id) {
          var matchedThumb = qsa("[data-gallery-thumb]", gallery).find(function (thumb) {
            return String(thumb.dataset.mediaId) === String(variant.media_id);
          });
          if (matchedThumb) matchedThumb.click();
        }
        if (atcBtn) { atcBtn.disabled = !variant.available; atcBtn.textContent = variant.available ? (atcBtn.dataset.labelAvailable || 'Add to Cart') : 'Sold Out'; }
        if (stickyAtcBtn) { stickyAtcBtn.disabled = !variant.available; }
      }
    });
  });

  /* ---------------- Size guide modal ---------------- */
  var sizeGuideModal = qs('[data-size-guide-modal]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-size-guide-open]')) {
      if (sizeGuideModal) { sizeGuideModal.classList.add('is-open'); sizeGuideModal.setAttribute('aria-hidden', 'false'); }
    }
    if (e.target.closest('[data-size-guide-close]')) {
      if (sizeGuideModal) { sizeGuideModal.classList.remove('is-open'); sizeGuideModal.setAttribute('aria-hidden', 'true'); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sizeGuideModal) { sizeGuideModal.classList.remove('is-open'); sizeGuideModal.setAttribute('aria-hidden', 'true'); }
  });

  /* ---------------- Personalization: image upload preview ---------------- */
  qsa('[data-upload-dropzone]').forEach(function (zone) {
    var input = qs('input[type="file"]', zone);
    var preview = qs('[data-upload-preview]', zone.closest('.personalize-box') || zone.parentElement);

    function renderFiles(files) {
      if (!preview) return;
      preview.innerHTML = '';
      Array.prototype.slice.call(files).slice(0, 6).forEach(function (file) {
        if (!file.type.startsWith('image/')) return;
        var reader = new FileReader();
        reader.onload = function (e) {
          var item = document.createElement('div');
          item.className = 'upload-preview__item';
          item.innerHTML = '<img src="' + e.target.result + '" alt="">' +
            '<button type="button" class="upload-preview__remove" aria-label="Remove image">×</button>';
          preview.appendChild(item);
        };
        reader.readAsDataURL(file);
      });
    }

    if (input) {
      input.addEventListener('change', function () { renderFiles(input.files); });
    }
    ['dragover', 'dragenter'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) { e.preventDefault(); zone.classList.add('is-dragover'); });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) { e.preventDefault(); zone.classList.remove('is-dragover'); });
    });
    zone.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files && input) {
        input.files = e.dataTransfer.files;
        renderFiles(input.files);
      }
    });
    zone.addEventListener('click', function (e) {
      if (e.target === zone || e.target.closest('[data-upload-trigger]')) {
        if (input) input.click();
      }
    });
  });

  /* ---------------- Product tabs ---------------- */
  qsa('[data-product-tabs]').forEach(function (tabs) {
    qsa('[data-tab-trigger]', tabs).forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var target = trigger.dataset.tabTrigger;
        qsa('[data-tab-trigger]', tabs).forEach(function (t) { t.classList.remove('is-active'); });
        qsa('[data-tab-panel]', tabs).forEach(function (p) { p.classList.remove('is-active'); });
        trigger.classList.add('is-active');
        var panel = qs('[data-tab-panel="' + target + '"]', tabs);
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  /* ---------------- Sticky add-to-cart on mobile ---------------- */
  var stickyAtc = qs('[data-sticky-atc]');
  var formAtc = qs('[data-main-add-to-cart]');
  if (stickyAtc && formAtc) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(formAtc);
  }

  /* ---------------- Add to cart (AJAX) ---------------- */
  function cartAdd(formData, btn) {
    if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'Adding…'; }
    return fetch(routes.cart_add_url, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          showToast(res.data.description || 'Could not add this item to your cart.');
          return;
        }
        showToast('Added to your cart');
        refreshCartDrawer(true);
      })
      .catch(function () { showToast('Something went wrong. Please try again.'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btn = qs('[data-add-to-cart]', form);
    cartAdd(new FormData(form), btn);
  });

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = qs('#cart-drawer');
  function refreshCartDrawer(open) {
    fetch(routes.cart_url)
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (open && cartDrawer) cartDrawer.classList.add('is-open');
      }).catch(function () { showToast('Could not load your cart. Please try again.'); });
  }
  function renderCartDrawer(cart) {
    if (!cartDrawer) return;
    var itemsEl = qs('[data-cart-items]', cartDrawer);
    var subtotalEl = qs('[data-cart-subtotal]', cartDrawer);
    var barFill = qs('[data-free-shipping-fill]', cartDrawer);
    var barLabel = qs('[data-free-shipping-label]', cartDrawer);
    var threshold = parseInt((cartDrawer.dataset.freeShippingThreshold || '0'), 10) * 100;

    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="empty-state"><p>Your cart is empty.</p><a class="btn btn-primary" href="/collections/all">Start Shopping</a></div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        var personalisedPreview = item.properties && item.properties['_Personalised Preview'];
        var cartImage = personalisedPreview || item.image || '';
        var props = Object.keys(item.properties || {}).filter(function (k) { return item.properties[k] && k.indexOf('_') !== 0; })
          .map(function (k) { return '<div>' + k + ': ' + item.properties[k] + '</div>'; }).join('');
        return '<div class="cart-line" data-line-key="' + item.key + '">' +
          '<img src="' + cartImage + '" alt="' + item.product_title + '">' +
          '<div><div style="font-weight:600;font-size:.9rem;">' + item.product_title + '</div>' +
          '<div class="text-muted" style="font-size:.8rem;">' + (item.variant_title || '') + '</div>' +
          '<div class="cart-line__props">' + props + '</div>' +
          '<div class="qty-selector" style="margin-top:.5rem;transform:scale(.85);transform-origin:left;">' +
          '<button type="button" data-cart-qty="-1" data-key="' + item.key + '">−</button>' +
          '<input type="text" readonly value="' + item.quantity + '">' +
          '<button type="button" data-cart-qty="1" data-key="' + item.key + '">+</button></div></div>' +
          '<div><div style="font-weight:700;">' + money(item.final_line_price) + '</div>' +
          '<button type="button" data-cart-remove data-key="' + item.key + '" class="btn-ghost btn-sm" style="padding-left:0;">Remove</button></div>' +
          '</div>';
      }).join('');
    }
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (barFill && threshold > 0) {
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      barFill.style.width = pct + '%';
      if (barLabel) {
        barLabel.textContent = cart.total_price >= threshold
          ? 'You unlocked free shipping! 🎉'
          : 'Add ' + money(threshold - cart.total_price) + ' more for free shipping';
      }
    }
  }
  function money(cents) {
    return '₹' + (cents / 100).toFixed(0);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      refreshCartDrawer(true);
    }
    if (e.target.closest('[data-cart-close]') || (cartDrawer && e.target.classList.contains('cart-drawer__overlay'))) {
      if (cartDrawer) cartDrawer.classList.remove('is-open');
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      changeLine(removeBtn.dataset.key, 0);
    }
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      var delta = parseInt(qtyBtn.dataset.cartQty, 10);
      var lineEl = qtyBtn.closest('[data-line-key]');
      var qtyInput = qs('input', lineEl);
      var next = Math.max(0, parseInt(qtyInput.value, 10) + delta);
      changeLine(qtyBtn.dataset.key, next);
    }
  });

  function changeLine(key, quantity) {
    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCartDrawer(cart);
      qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    });
  }

  

  /* ---------------- Generic slider (testimonials, etc.) ---------------- */
  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-slider-prev]');
    var nextBtn = e.target.closest('[data-slider-next]');
    var btn = prevBtn || nextBtn;
    if (!btn) return;
    var wrap = btn.closest('.testimonial-slider-wrap') || btn.parentElement.parentElement;
    var slider = wrap ? qs('[data-slider]', wrap) : null;
    if (!slider) return;
    var item = qs('[data-slider-item]', slider);
    var amount = item ? item.getBoundingClientRect().width + 16 : slider.clientWidth * 0.85;
    slider.scrollBy({ left: prevBtn ? -amount : amount, behavior: 'smooth' });
  });

  /* ---------------- Hero slider ---------------- */
  qsa('[data-hero-slider]').forEach(function (slider) {
    var slides = qsa('[data-hero-slide]', slider);
    var dots = qsa('[data-hero-dot]', slider);
    if (slides.length < 2) return;
    var current = 0;
    var timer;
    var autoplay = slider.dataset.autoplay === 'true';
    var speed = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }
    function stopAutoplay() { clearInterval(timer); }

    var nextBtn = qs('[data-hero-next]', slider);
    var prevBtn = qs('[data-hero-prev]', slider);
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    startAutoplay();
  });

  /* ---------------- Scroll-reveal animations ---------------- */
  var revealTargets = qsa('.product-card, .category-card, .testimonial-card, .step, .trust-item, .occasion-pill, .card');
  revealTargets.forEach(function (el) { el.classList.add('reveal-init'); });
  if ('IntersectionObserver' in window && revealTargets.length) {
    var revealIo = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealTargets.forEach(function (el) { revealIo.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------------- Wishlist (localStorage-free — placeholder using sessionStorage on storefront) ---------------- */
  qsa('[data-wishlist-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.classList.toggle('is-active');
      showToast(btn.classList.contains('is-active') ? 'Added to wishlist' : 'Removed from wishlist');
    });
  });

}());

